import { InjectionToken } from '@angular/core';
import { IConnectivityService } from './connectivity-service.interface';

export const CONNECTIVITY_SERVICE = new InjectionToken<IConnectivityService>(
  'CONNECTIVITY_SERVICE'
);
